var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletDoorAuto = function SvgIcToiletDoorAuto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.657,
    height: 23.825,
    x: 12.32,
    y: 4.553,
    fill: "#67AEFF",
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.928,
    height: 23.825,
    x: 6.516,
    y: 4.553,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4.234 28.378h24.03"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.067,
    cy: 16.251,
    r: 1.208,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.499 19.91a1.85 1.85 0 0 1-1.849 1.802h-1.515a1.85 1.85 0 0 1-1.85-1.832 4 4 0 0 1-.724.804c-.907.772-2.089 1.113-3.302 1.116h-.01c-.878-.002-1.74-.181-2.492-.573a1.83 1.83 0 0 1-1.248.485H7.847a1.85 1.85 0 0 1-1.745-1.237 1.85 1.85 0 0 1-1.745 1.237h-1.67a1.85 1.85 0 0 1-1.755-2.433l2.262-6.795a1.85 1.85 0 0 1 1.754-1.265h2.308c.64 0 1.222.33 1.557.85.329-.511.903-.85 1.556-.85h1.535c.536 0 1.018.228 1.355.59.338-.362.82-.59 1.355-.59h1.535q.217 0 .42.048.201-.047.419-.048h5.81c.484 0 .925.187 1.255.492.763-.4 1.622-.59 2.494-.59 1.34 0 2.652.454 3.633 1.432.987.985 1.495 2.355 1.495 3.912s-.508 2.928-1.495 3.913c-.981.977-2.292 1.432-3.633 1.432-1.352 0-2.665-.46-3.645-1.44a5 5 0 0 1-.403-.46",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.545 20.13c1.925 0 3.447-1.29 3.447-3.664s-1.522-3.664-3.447-3.664c-1.946 0-3.452 1.29-3.457 3.664.005 2.358 1.511 3.663 3.457 3.663m0-1.636c-.985-.004-1.527-.718-1.527-2.028 0-1.315.542-2.03 1.527-2.03.975 0 1.521.715 1.516 2.03.005 1.31-.541 2.024-1.516 2.028m-9.56-5.594a.17.17 0 0 0-.168.168v1.18c0 .094.075.169.168.169h1.811c.093 0 .168.075.168.168v5.278c0 .093.076.168.168.168h1.516a.17.17 0 0 0 .168-.168v-5.278c0-.093.075-.168.168-.168h1.81a.17.17 0 0 0 .169-.168v-1.18a.17.17 0 0 0-.168-.169zm-2.541.168c0-.092.075-.168.168-.168h1.535c.093 0 .168.075.168.168v4.412c.005 1.615-1.236 2.635-3.063 2.64-1.832-.005-3.058-1.025-3.053-2.64v-4.412c0-.092.075-.168.168-.168h1.535c.093 0 .168.075.168.168v4.245c0 .689.492 1.181 1.182 1.181.7 0 1.187-.492 1.192-1.181zM2.524 19.81a.168.168 0 0 0 .16.22h1.67c.075 0 .14-.048.162-.118l.351-1.16a.17.17 0 0 1 .16-.12h2.14c.074 0 .14.049.16.12l.357 1.16c.021.07.086.119.16.119h1.662a.168.168 0 0 0 .16-.221l-2.253-6.795a.17.17 0 0 0-.16-.115H4.947a.17.17 0 0 0-.16.115zm4.268-2.813a.168.168 0 0 1-.161.217H5.563a.168.168 0 0 1-.16-.217l.654-2.148a.04.04 0 0 1 .076 0z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.25.465h32v32h-32z"
  })))));
};
export default SvgIcToiletDoorAuto;